// removed by extract-text-webpack-plugin
module.exports = {"contents":"BattleTitleTooltip_contents--28yDi","title":"BattleTitleTooltip_title--2UroL","subtitle":"BattleTitleTooltip_subtitle--AJpgk","rewardSubtitle":"BattleTitleTooltip_rewardSubtitle--1Mvu2","schedule":"BattleTitleTooltip_schedule--2XMbX","list":"BattleTitleTooltip_list--33Z01","item":"BattleTitleTooltip_item--1LMTb","reward":"BattleTitleTooltip_reward--1eydC"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/BattleTitleTooltip/BattleTitleTooltip.scss
// module id = 489
// module chunks = 11 12